/*
 * Select filled
*/
	const siteSelects = document.querySelectorAll('select')

	if (siteSelects) {
		siteSelects.forEach(e => {
			e.value !== '' ? e.classList.add('is--selected') : e.classList.remove('is--selected')

			e.addEventListener('change', c => {
				e.value !== '' ? e.classList.add('is--selected') : e.classList.remove('is--selected')
			})
		})
	}
